import Swiper from "swiper";
import { Pagination, Navigation, Autoplay } from "swiper/modules";

export function sponsor_swiper() {
    const $swiper = '.sponsor_swiper';
    const container = $swiper + ' .swiper';
    const pagination = $swiper + ' .swiper-pagination';
    const button_next = $swiper + ' .swiper-button-next';
    const button_prev = $swiper + ' .swiper-button-prev';

    const mySwiper = new Swiper(container, {
        modules: [Pagination, Navigation, Autoplay],
        grabCursor: true,
        slidesPerView: 'auto',
        slidesPerGroupAuto: true,
        slidesPerGroup: 2,
        loop: true,
        speed: 600,
        autoplay: {
            delay: 2000,
        },
        pagination: {
            el: pagination,
            clickable: true,
        },
        navigation: {
            nextEl: button_next,
            prevEl: button_prev,
        },
        a11y: {
            enabled: true,
            firstSlideMessage: "第一則",
            lastSlideMessage: "最後一則",
            paginationBulletMessage: "到第 {{index}} 則",
        },
    });
}